import React from 'react';
import PropTypes from 'prop-types';
import { faPalette } from '@fortawesome/free-solid-svg-icons/faPalette';
import { faCrosshairs } from '@fortawesome/free-solid-svg-icons/faCrosshairs';
import { Accordion, Tabs } from '@appcues/sonar';
import { EditorShape } from 'entities/step-groups/shape';
import { ContentShape } from 'entities/step-children/shape';
import { hasSurveyBlockType } from 'lib/block/survey-handler';
import { EMBED } from 'lib/trait/trait';
import { COLOR_MODES } from 'lib/user-preferences/user-preferences';
import { Content } from 'components/SideBarSettings/Shared/styled';
import AlignmentSpacing from 'components/SideBarSettings/Shared/AlignmentSpacing';
import Container from 'components/SideBarSettings/Shared/Container';
import ThemeVariantSelect from 'components/SideBarSettings/Shared/ThemeVariantSelect';
import Details from './Details';
import FrameTarget from './FrameTarget';

export function EmbedSettings({
  selectedStepChild,
  isStepGroupFirstChild,
  editor,
  content,
  stepChildrenIds = [],
  colorMode,
  onChange,
}) {
  const { frameID, style } = editor;
  const isSingleStep = stepChildrenIds.length === 1;
  const hasSurveyBlock = hasSurveyBlockType(content);

  const styleSection = (
    <Accordion.Root
      collapsible="true"
      defaultValue={['details', 'container']}
      type="multiple"
    >
      <ThemeVariantSelect type={EMBED} editor={editor} onChange={onChange} />
      <Details
        editor={editor}
        isSingleStep={isSingleStep}
        hasSurveyBlock={hasSurveyBlock}
        onChange={onChange}
      />

      <Container editor={editor} colorMode={colorMode} onChange={onChange} />

      <AlignmentSpacing
        style={style}
        spacingLabel="Content"
        onChange={onChange}
        hasPadding
        hasMargin
      />
    </Accordion.Root>
  );

  const tabs = (
    <Tabs.Root key={selectedStepChild} defaultValue="style" align="stretch">
      <Tabs.List>
        <Tabs.Trigger value="style" icon={faPalette}>
          Style
        </Tabs.Trigger>
        <Tabs.Trigger value="target" icon={faCrosshairs}>
          Target
        </Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content value="style">{styleSection}</Tabs.Content>
      <Tabs.Content value="target">
        <FrameTarget frameID={frameID} onChange={onChange} />
      </Tabs.Content>
    </Tabs.Root>
  );

  return <Content>{isStepGroupFirstChild ? tabs : styleSection}</Content>;
}

EmbedSettings.propTypes = {
  selectedStepChild: PropTypes.string,
  isStepGroupFirstChild: PropTypes.bool,
  editor: EditorShape,
  content: ContentShape,
  stepChildrenIds: PropTypes.arrayOf(PropTypes.string),
  colorMode: PropTypes.oneOf(COLOR_MODES),
  onChange: PropTypes.func,
};

export default EmbedSettings;
